import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../../../i18n/i18n'
import './hero.scss'

export function Hero() {
  const navigate = useNavigate()
  const { t } = useI18n()
  return (
    <section className="hero">
      <div className="hero__text">
        <span className="eyebrow">{t('hero.eyebrow')}</span>
        <h1 className="hero__title">
          {t('hero.titlePre')}<br />
          {t('hero.titleMid')} <span className="hero__title-accent">{t('hero.titleAccent')}</span>
        </h1>
        <p className="hero__sub">{t('hero.sub')}</p>
        <div className="hero__actions">
          <button className="btn btn-primary" onClick={() => navigate('/contato')}>
            {t('hero.ctaPrimary')}
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/servicos')}>
            {t('hero.ctaSecondary')}
          </button>
        </div>
      </div>

      <div className="hero__media">
        <img
          className="hero__img"
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=70"
          alt="Planejamento e análise de consultoria empresarial"
          loading="eager"
        />
        <div className="hero__badge hero__badge--rating">
          <strong>4,9</strong>
          <span>★★★★★<br />{t('hero.badgeRating')}</span>
        </div>
        <div className="hero__badge hero__badge--count">
          <strong>+100</strong>
          <span>{t('hero.badgeCount')}</span>
        </div>
      </div>
    </section>
  )
}
